const state = {
  categories: [
    {
      code: "existing_data",
      title: "Existing Data",
      sub: true,
      tabs: []
    },
    {
      code: "scenario_analysis",
      title: "Scenario Analysis",
      sub: false,
      tabs: [
        {
          title: "Scenario",
          code: "scenario_analysis_scenario",
          url: "https://srapc-under-construction.geodemosolutions.com/"
        }
      ]
    }
  ],
  subCategories: {
    existing_data: [
      {
        title: "Transport",
        tabs: [
          {
            title: "GIS",
            code: "transport_gis",
            url: "https://au1gis.solutions.arcadis.com/arcgis/apps/webappviewer/index.html?id=e18259573f4c4d3db0fac7779375da03"
          },
          {
            title: "Information Exchange",
            code: "transport_information_exchange",
            url: "https://srapc-under-construction.geodemosolutions.com/"
          },
          {
            title: "Comment",
            code: "transport_comment",
            url: "https://comment-envi-tool.geodemosolutions.com/"
          },
          {
            title: "Document Issue",
            code: "transport_document_issue",
            url: "https://cherry-report-upload.geodemosolutions.com/"
          }
        ]
      },
      {
        title: "Flood",
        tabs: [
          {
            title: "GIS",
            code: "flood_gis",
            url: "https://au1gis.solutions.arcadis.com/arcgis/apps/webappviewer/index.html?id=e18259573f4c4d3db0fac7779375da03"
          },
          {
            title: "Information Exchange",
            code: "flood_information_exchange",
            url: "https://srapc-under-construction.geodemosolutions.com/"
          },
          {
            title: "Comment",
            code: "flood_comment",
            url: "https://comment-envi-tool.geodemosolutions.com/"
          },
          {
            title: "Document Issue",
            code: "flood_document_issue",
            url: "https://cherry-report-upload.geodemosolutions.com/"
          }
        ]
      },
      {
        title: "Utilities",
        tabs: [
          {
            title: "GIS",
            code: "utilities_gis",
            url: "https://au1gis.solutions.arcadis.com/arcgis/apps/webappviewer/index.html?id=e18259573f4c4d3db0fac7779375da03"
          },
          {
            title: "Information Exchange",
            code: "utilities_information_exchange",
            url: "https://srapc-under-construction.geodemosolutions.com/"
          },
          {
            title: "Comment",
            code: "utilities_comment",
            url: "https://comment-envi-tool.geodemosolutions.com/"
          },
          {
            title: "Document Issue",
            code: "utilities_document_issue",
            url: "https://cherry-report-upload.geodemosolutions.com/"
          }
        ]
      },
      {
        title: "Renewables",
        tabs: [
          {
            title: "GIS",
            code: "renewables_gis",
            url: "https://au1gis.solutions.arcadis.com/arcgis/apps/webappviewer/index.html?id=e18259573f4c4d3db0fac7779375da03"
          },
          {
            title: "Information Exchange",
            code: "renewables_information_exchange",
            url: "https://srapc-under-construction.geodemosolutions.com/"
          },
          {
            title: "Comment",
            code: "renewables_comment",
            url: "https://comment-envi-tool.geodemosolutions.com/"
          },
          {
            title: "Document Issue",
            code: "renewables_document_issue",
            url: "https://cherry-report-upload.geodemosolutions.com/"
          }
        ]
      }
    ],

  },
  defaultTabs: [
    {
      title: "INSIGHT",
      code: "insight",
      url: "https://app.powerbi.com/reportEmbed?reportId=1fcb7c77-721a-4d62-bce8-ca353cd80e68&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
    },
    {
      title: "GIS",
      code: "gis",
      url: "img/assets/tabs/GISTab.png"
    },
    {
      title: "CONOPS",
      code: "conops",
      url: "img/assets/tabs/GISTab.png"
    },
    {
      title: "FMECA",
      code: "fmeca",
      url: "img/assets/tabs/ConopsTab.png"
    },
    {
      title: "RAW DATA",
      code: "raw_data",
      url: "img/assets/tabs/ConopsTab.png"
    }
  ],
  currentSelectedCategory: "",
  currentSelectedSubCategory: "",
  activeElement: "",
  currentSelectedTab: {
  },
  activeTabFlags: {
    scenario_analysis_scenarioSection: false,
    transport_gisSection: false,
    transport_information_exchangeSection: false,
    transport_commentSection: false,
    transport_document_issueSection: false,
    flood_gisSection: false,
    flood_information_exchangeSection: false,
    flood_commentSection: false,
    flood_document_issueSection: false,
    utilities_gisSection: false,
    utilities_information_exchangeSection: false,
    utilities_commentSection: false,
    utilities_document_issueSection: false,
    renewables_gisSection: false,
    renewables_information_exchangeSection: false,
    renewables_commentSection: false,
    renewables_document_issueSection: false
  }
}

function initialState() {
  return {
    categories: [
      {
        code: "existing_data",
        title: "Existing Data",
        sub: true,
        tabs: []
      },
      {
        code: "scenario_analysis",
        title: "Scenario Analysis",
        sub: false,
        tabs: [
          {
            title: "Scenario",
            code: "scenario_analysis_scenario",
            url: "https://srapc-under-construction.geodemosolutions.com/"
          }
        ]
      }
    ],
    subCategories: {
      existing_data: [
        {
          title: "Transport",
          tabs: [
            {
              title: "GIS",
              code: "transport_gis",
              url: "https://au1gis.solutions.arcadis.com/arcgis/apps/webappviewer/index.html?id=e18259573f4c4d3db0fac7779375da03"
            },
            {
              title: "Information Exchange",
              code: "transport_information_exchange",
              url: "https://srapc-under-construction.geodemosolutions.com/"
            },
            {
              title: "Comment",
              code: "transport_comment",
              url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "Document Issue",
              code: "transport_document_issue",
              url: "https://cherry-report-upload.geodemosolutions.com/"
            }
          ]
        },
        {
          title: "Flood",
          tabs: [
            {
              title: "GIS",
              code: "flood_gis",
              url: "https://au1gis.solutions.arcadis.com/arcgis/apps/webappviewer/index.html?id=e18259573f4c4d3db0fac7779375da03"
            },
            {
              title: "Information Exchange",
              code: "flood_information_exchange",
              url: "https://srapc-under-construction.geodemosolutions.com/"
            },
            {
              title: "Comment",
              code: "flood_comment",
              url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "Document Issue",
              code: "flood_document_issue",
              url: "https://cherry-report-upload.geodemosolutions.com/"
            }
          ]
        },
        {
          title: "Utilities",
          tabs: [
            {
              title: "GIS",
              code: "utilities_gis",
              url: "https://au1gis.solutions.arcadis.com/arcgis/apps/webappviewer/index.html?id=e18259573f4c4d3db0fac7779375da03"
            },
            {
              title: "Information Exchange",
              code: "utilities_information_exchange",
              url: "https://srapc-under-construction.geodemosolutions.com/"
            },
            {
              title: "Comment",
              code: "utilities_comment",
              url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "Document Issue",
              code: "utilities_document_issue",
              url: "https://cherry-report-upload.geodemosolutions.com/"
            }
          ]
        },
        {
          title: "Renewables",
          tabs: [
            {
              title: "GIS",
              code: "renewables_gis",
              url: "https://au1gis.solutions.arcadis.com/arcgis/apps/webappviewer/index.html?id=e18259573f4c4d3db0fac7779375da03"
            },
            {
              title: "Information Exchange",
              code: "renewables_information_exchange",
              url: "https://srapc-under-construction.geodemosolutions.com/"
            },
            {
              title: "Comment",
              code: "renewables_comment",
              url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "Document Issue",
              code: "renewables_document_issue",
              url: "https://cherry-report-upload.geodemosolutions.com/"
            }
          ]
        }
      ],

    },
    defaultTabs: [
      {
        title: "INSIGHT",
        code: "insight",
        url: "https://app.powerbi.com/reportEmbed?reportId=1fcb7c77-721a-4d62-bce8-ca353cd80e68&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
      },
      {
        title: "GIS",
        code: "gis",
        url: "img/assets/tabs/GISTab.png"
      },
      {
        title: "CONOPS",
        code: "conops",
        url: "img/assets/tabs/GISTab.png"
      },
      {
        title: "FMECA",
        code: "fmeca",
        url: "img/assets/tabs/ConopsTab.png"
      },
      {
        title: "RAW DATA",
        code: "raw_data",
        url: "img/assets/tabs/ConopsTab.png"
      }
    ],
    currentSelectedCategory: "",
    currentSelectedSubCategory: "",
    activeElement: "",
    currentSelectedTab: {
    },
    activeTabFlags: {
      scenario_analysis_scenarioSection: false,
      transport_gisSection: false,
      transport_information_exchangeSection: false,
      transport_commentSection: false,
      transport_document_issueSection: false,
      flood_gisSection: false,
      flood_information_exchangeSection: false,
      flood_commentSection: false,
      flood_document_issueSection: false,
      utilities_gisSection: false,
      utilities_information_exchangeSection: false,
      utilities_commentSection: false,
      utilities_document_issueSection: false,
      renewables_gisSection: false,
      renewables_information_exchangeSection: false,
      renewables_commentSection: false,
      renewables_document_issueSection: false
    }
  }
}

const mutations = {
  upCounter(state) {
    state.counter += 1
  },
  setSelectedZone(state, payload) {
    var selectedZone = state.zones.filter(obj=>obj.code == payload)[0]
    state.selectedZone = selectedZone
  },
  setCategoriesFromZone(state, payload) {
    var categories = state.categories[payload]
    state.selectedCategories = categories
  },
  setSelectedLine(state, payload) {
    var selectedLine = state.lines.filter(obj=>obj.code == payload)[0]
    state.selectedLine = selectedLine
    console.log(selectedLine);
  },
  setSelectedStations(state, payload) {
    state.selectedStations = state.stations[payload]
  },
  setActiveTabFlags(state, payload) {
    Object.keys(state.activeTabFlags).forEach(item=>{
      state.activeTabFlags[item] = false
    })
    console.log(state.activeTabFlags);
    console.log(payload);
    state.activeTabFlags[payload] = true
  },
  setSelectedPortfolio(state, payload) {
    var selectedPortfolio = state.portfolios.filter(obj=>obj.code == payload)[0]
    state.selectedPortfolio = selectedPortfolio
  },
  setSelectedProjects(state, payload) {
    state.selectedProjects = state.projects[payload]
  },
  setCurrentSelectedSubCategory(state, payload) {
    state.currentSelectedSubCategory = payload
  },
  setActiveSidebarElement(state, payload) {
    state.activeElement = payload
  },
  setCurrentSelectedCategory(state, payload) {
    state.currentSelectedCategory = payload
  },
  setCurrentSelectedTab(state, payload) {
    // if(payload.title != "Overview"){
    //
    //   // if(state.currentSelectedSubCategory == "Noisewall"){
    //   if(state.subCategories[state.currentSelectedCategory.code].filter(obj=>obj.title == state.currentSelectedSubCategory)[0].tabs.length == 0){
    //     payload.tabs = state.defaultTabs
    //   }
    //   // else{
    //   //   payload.tabs = state.defaultTabs
    //   // }
    //
    // }
    state.currentSelectedTab = payload
  },
}

const actions = {

}

const getters = {

}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
